import { useState } from 'react';
import { Button } from '@mui/material';

import { Strings } from '@app/constants';
import { AttachmentViewer, ProfileCard } from '@app/components/card';
import { ILeaveDetails } from '../types';

interface Props {
  leaveData?: ILeaveDetails;
}

export const LeaveInfo = ({ leaveData }: Props) => {
  const [openViewer, setOpenViewer] = useState(false);
  const [selectedAttachment, setSelectedAttachment] = useState<string | null>(null);

  const handleOpenViewer = (attachment: string) => {
    setSelectedAttachment(attachment);
    setOpenViewer(true);
  };

  const handleCloseViewer = () => {
    setOpenViewer(false);
    setSelectedAttachment(null);
  };

  const updatedBy =
    `${leaveData?.approvedUser?.firstName ?? ''} ${
      leaveData?.approvedUser?.lastName ?? ''
    }`.trim() || 'NA';
  const fields = [
    Strings.field.firstName,
    Strings.field.lastName,
    Strings.field.phone,
    Strings.field.email,
    Strings.field.type,
    Strings.field.from,
    Strings.field.to,
    Strings.field.reason,
    Strings.field.status,
    Strings.field.reasonOfDecline,
    Strings.field.updatedBy,
    Strings.field.attachment,
  ];

  const data = [
    leaveData?.user?.firstName ?? 'NA',
    leaveData?.user?.lastName ?? 'NA',
    leaveData?.user?.phone ?? 'NA',
    leaveData?.user?.email ?? 'NA',
    leaveData?.leaveType ?? 'NA',
    leaveData?.from ?? 'NA',
    leaveData?.to ?? 'NA',
    leaveData?.reason ?? 'NA',
    leaveData?.update ?? 'NA',
    leaveData?.reasonOfDecline ?? 'NA',
    updatedBy,
    leaveData?.image ? (
      <>
        <Button
          key="resume"
          color="primary"
          onClick={() => {
            if (leaveData?.image) {
              handleOpenViewer(leaveData.image);
            }
          }}
          sx={{ padding: 0 }}
        >
          {Strings.button.clickHere}
        </Button>
      </>
    ) : (
      'NA'
    ),
  ];

  return (
    <>
      <ProfileCard
        fields={fields}
        data={data}
        Src={
          leaveData?.user?.profileImage ??
          `${leaveData?.user?.firstName ?? ''} ${leaveData?.user?.lastName ?? ''}`
        }
        title={Strings.profile.leaveInformation}
      />
      <AttachmentViewer
        open={openViewer}
        onClose={handleCloseViewer}
        resume={selectedAttachment ?? undefined}
        titleName={Strings.field.attachment}
      />
    </>
  );
};
